export enum hoverBtns {
    Default,
    Delete,
    Edit,
    Save
}

export enum DataTestIds {
    recommendedSearchIcon = 'rorecommended-search-icon',
    searchesDropdownTrigger = 'search-trigger-wrapper',
    recommendationIndication = 'recommendation-indication'
}
